<div class="navbar__container py-2">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <app-breadcrumb [beforeNav]="info.change ?? beforeNav"></app-breadcrumb>
      </div>
    </div>
    <nav
      class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mt-0 mt-md-4">
      <!-- <div *ngIf="ruta.split('/')[1] == 'expediente' && ruta.split('/').length <= 2
        && (userType?.Id == 2 || userType?.Id == 1); else btnVolver">
        <div class="order-2 order-md-1"></div>
      </div> -->
      <!-- <ng-template #btnVolver> -->
        <div class="order-2 order-md-1">
          <button
            type="button"
            class="btn-govco fill-btn-govco icon-btn-govco btn__volver mt-4 mt-md-0 flecha"
            (click)="goBack()"
            (keyup)="goBack()"
            href="javascript:void(0);"
            aria-label="Volver">
            <span
              class="govco-svg govco-arrow-circle-left"
              aria-hidden="true"></span>
            <span>{{ 'volver' | translate }}</span>
          </button>
        </div>
      <!-- </ng-template> -->
      <div
        class="d-flex flex-column flex-md-row align-items-center mt-4 mt-md-0 order-1 order-md-2">
        <div class="d-flex flex-row align-items-center justify-content-center justify-content-xl-around botones">
          <button
            type="button"
            class="btn btn-actions btn-just-icon p-0 btn-sm mx-1 hvr-shrink descripcion-emergente-govco bottom d-flex"
            (click)="cargarModal()"
            aria-label="Servicio">
            <span class="tiptext">{{"tooltip_nav.servicio" | translate}}</span>
            <span class="govco-svg govco-headset icos__nav__user"></span>
          </button>
          <div class="btn-group">
            <button
              id="informacion"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              class="btn btn-actions btn-just-icon p-0 btn-sm mx-1 hvr-shrink descripcion-emergente-govco bottom d-flex"
              (mouseenter)="mostrarTooltip('informacion')"
              (mouseleave)="ocultarTooltip()"
              aria-label="Acerca de">
              <span class="tiptext" *ngIf="tooltipVisible === 'informacion'">{{"tooltip_nav.acerca" | translate}}</span>
              <span class="govco-svg govco-question-circle icos__nav__user"></span>
            </button>
            <div
              class="dropdown-menu dropdown-menu-informacion"
              aria-labelledby="informacion">
              <ng-container
                *ngIf="info.tituloPantalla && info.tituloPantalla !== ''">
                <p class="text2-tipografia-govco title-color">
                  {{ info.tituloPantalla }}
                </p>
                <p class="text3-tipografia-govco description-color">
                  {{ info.descripcionPantalla }}
                </p>
              </ng-container>
              <p class="text2-tipografia-govco title-color">
                {{"tooltip_nav.otros_recursos" | translate}}
              </p>
              <button
                class="link-tipografia-govco link-color hvr-forward"
                *ngIf="info.pasos && info.pasos.length > 0"
                type="button"
                (click)="comenzarGuia()"
                [attr.aria-label]="'tooltip_nav.guia' | translate">
                <span class="govco-svg govco-compass" aria-hidden="true"></span>
                {{ 'tooltip_nav.guia' | translate }}
              </button>
              <button
                class="link-tipografia-govco link-color hvr-forward"
                type="button"
                (click)="cargarPreguntas()"
                [attr.aria-label]="'tooltip_nav.preguntas' | translate">
                <span class="govco-svg govco-question-circle" aria-hidden="true"></span>
                {{ 'tooltip_nav.preguntas' | translate }}
              </button>
            </div>
          </div>

          <button
            id="glosario"
            type="button"
            [routerLinkActive]="'active'"
            [routerLink]="['/glosario-entidad']"
            class="btn btn-actions btn-just-icon p-0 btn-sm mx-1 hvr-shrink descripcion-emergente-govco bottom d-flex"
            (mouseenter)="mostrarTooltip('glosario')"
            (mouseleave)="ocultarTooltip()"
            aria-label="Glosario">
            <span class="tiptext" *ngIf="tooltipVisible === 'glosario'">{{"tooltip_nav.glosario" | translate}}</span>
            <span class="govco-svg govco-book-open icos__nav__user"></span>
          </button>

          <ng-container *ngIf="showAlertas" [ngSwitch]="tipoAlerta">
            <app-visualizar-alertas
              *ngSwitchCase="'general'"></app-visualizar-alertas>
            <app-visualizar-alertas-expediente
              *ngSwitchCase="'expediente'"
              [expedienteId]="idExpediente"></app-visualizar-alertas-expediente>
            <app-visualizar-alertas-tramites
             *ngSwitchCase="'tramites'"></app-visualizar-alertas-tramites>
          </ng-container>
        </div>
        <div class="mt-3 mt-md-0 ms-0 ms-md-3">
          <app-detalle />
        </div>
      </div>
    </nav>
  </div>
</div>
